module.exports = __webpack_public_path__ + "img/cs-landing.671ab1ca.jpg";